export const stellazhi = {
    metall_type: [
        {
            actual: true,
            name: "stellazh__sa__1000x700x300",
            pageName: "sa",
            tempName: "sa",
            glbPath: "stellazhi/",
            glbName: "stellazh_sa.glb",
            nextMenu: "sa",
            menuTitle: "Стеллаж СА",
            title: "Стеллаж СА",
            imgName: "stellazh__sa.webp",
            allArrTable: "allStellazhi",
            defaultWidth: 700,
            defaultDepth: 300,
        },
        {
            actual: true,
            name: "stellazh__sab__1750x820x450",
            pageName: "sab",
            tempName: "sab",
            glbPath: "stellazhi/",
            glbName: "stellazh_sab.glb",
            nextMenu: "sab",
            menuTitle: "Стеллаж САБ",
            title: "Стеллаж САБ",
            imgName: "stellazh__sab.webp",
            allArrTable: "allStellazhi",
            defaultWidth: 820,
            defaultDepth: 450,
        },
        {
            actual: true,
            name: "stellazh__sum__1800x800x600",
            pageName: "sum",
            tempName: "sum",
            glbPath: "stellazhi/",
            glbName: "stellazh_sum.glb",
            nextMenu: "sum",
            menuTitle: "Стеллаж СУМ",
            title: "Стеллаж СУМ",
            imgName: "stellazh__sum.webp",
            allArrTable: "allStellazhi",
            defaultWidth: 800,
            defaultDepth: 600,
        },
    ],
    construct_type: [],
};
